import React, { FC, memo } from 'react'
import Badge from 'components/ui/Badge'

interface PropsI {
  from: number | null
  to: number | null
  period: string
  currency: string
  className?: string
}

const SalaryRate: FC<PropsI> = ({ className, currency, from, to, period }) => {
  // Don't render if both from and to are 0 or falsy
  if (!from && !to) return null

  const text = `${currency}${from || 0}${to ? ` - ${to}` : ''} /${period}`
  return (
    <Badge
      text={text}
      variant="outline"
      className={className}
      style={{
        height: 40,
        padding: '10px 14px',
        borderRadius: 24,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
      }}
    />
  )
}

export default memo(SalaryRate)
